import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';

import useAcademyFilterValue from './useAcademyFilterValue';
import useAcademyOptionsQuery from './useAcademyOptionsQuery';

export const AcademyEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useFilterValues: useAcademyFilterValue,
  useOptionsQuery: useAcademyOptionsQuery,
};
